import { render } from "./admin_menu.vue?vue&type=template&id=41d6192f&scoped=true"
import script from "./admin_menu.vue?vue&type=script&lang=js"
export * from "./admin_menu.vue?vue&type=script&lang=js"

import "./admin_menu.vue?vue&type=style&index=0&id=41d6192f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\holo\\project\\non-contact-reception\\no-contact\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d6192f"]])

export default __exports__